<div style="height: 80vh; overflow: auto;">
    <div style="background-color: white; padding: 20px 20px 0px 20px; ">
        <div class="class-erea" fxLayout="row" fxLayout.xs="column">
            <div class="class-mat-field" fxFlex="33" style="height: 100px;">
                <h3 class="stat-title">Registered students</h3>
                <div class="stat-value">{{this.data['registration']?.nb_student ?? 0}}</div>
                <div class="stat-trend">Total: {{this.data['registration']?.total_student ?? 0}}</div>
            </div>
            <div class="separator"></div>
            <div class="class-mat-field" fxFlex="33" style="height: 100px;">
                <div style="display: flex; justify-content: center;;">
                    <div>
                        <h3 class="stat-title">Android</h3>
                        <div class="stat-value">{{this.data['registration']?.nb_system_android ?? 0}}</div>
                        <div class="stat-trend">Total: {{this.data['registration']?.total_system_android ?? 0}}</div>
                    </div>
                    <div style="width: 3px; background-color: whitesmoke; margin: 0 10px 0 10px;"></div>
                    <div>
                        <h3 class="stat-title">IOS</h3>
                        <div class="stat-value">{{this.data['registration']?.nb_system_ios ?? 0}}</div>
                        <div class="stat-trend">Total: {{this.data['registration']?.total_system_ios ?? 0}}</div>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="class-mat-field" fxFlex="33" style="height: 100px;">
                <h3 class="stat-title">Subscriptions</h3>
                <div class="stat-value">{{this.data['registration']?.nb_subscription ?? 0}}</div>
                <div class="stat-trend">Total: {{this.data['registration']?.total_subscription ?? 0}}</div>
            </div>
            <div class="separator"></div>
            <div class="class-mat-field" fxFlex="33">
            <h2>ABonnement</h2>
            </div>
        </div>
    </div>

    <div style="background-color: white; padding: 20px 20px 0px 20px;">
        <div class="class-erea" fxLayout="row" fxLayout.xs="column" style="height: 400px;">
            <div class="class-mat-field" fxFlex="70">
                <canvas class="student-evolution"></canvas>
            </div>
            <div class="separator"></div>
            <div fxFlex="30" style="padding: 0 10px 0 10px; overflow: auto; background-color: whitesmoke;">
                <div>Guess visit enovsky.com</div>
                <table>
                    <thead>
                    <tr>
                        <th>
                            <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'activity_date', 'date')"></mat-icon>
                            <div class="column-name">Date</div>
                        </th>
                        <th>
                            <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'country', 'string')"></mat-icon>
                            <div class="column-name">Country</div>
                        </th>
                        <th>
                            <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'partner', 'string')"></mat-icon>
                            <div class="column-name">Partner</div>
                        </th>
                        <th>
                            <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'source', 'string')"></mat-icon>
                            <div class="column-name">Source</div>
                        </th>
                        <th>
                            <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'target', 'string')"></mat-icon>
                            <div class="column-name">Target</div>
                        </th>
                        <th>
                            <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_guess', 'number')"></mat-icon>
                            <div class="column-name">Nb Guess</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody *ngFor="let row of showedRows; let i = index">
                        <tr>
                            <td>{{ row['activity_date'] }}</td>
                            <td>{{ row['country'] }}</td>
                            <td>{{ row['partner'] }}</td>
                            <td>{{ row['source'] }}</td>
                            <td>{{ row['target'] }}</td>
                            <td>{{ row['nb_guess'] }}</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="showedRows.length === 0">
                        <tr ><td colspan="7" style="text-align: center;">No matching records found</td></tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div style="background-color: white; padding: 20px 20px 0px 20px;">
        <div class="class-erea" fxLayout="row" fxLayout.xs="column" style="height: 400px;">
            <div class="class-mat-field" fxFlex="50" style="padding-top: 5px;">
                <div fxLayout="row" fxLayout.xs="column">
                    <div class="class-mat-field" fxFlex="40">
                        <mat-select placeholder="User" [formControl]="userControl">
                            <input class="col-input-filter" [formControl]="userInputControl">
                            <mat-option [value]="0">Choose</mat-option>
                            <mat-option *ngFor="let user of allUsers" [value]="user.id">
                                <span class="option-user"><span class="avatar small-avatar" [style.background]="user.color || '#016F86'">{{ user.initials }}</span><span><strong>{{ user.full_name }}</strong><small>{{ user.email }} · {{ user.phone }}</small></span></span>
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="separator"></div>
                    <div class="class-mat-field" fxFlex="20"  fxLayoutAlign="center center">
                        <button class="button-validate-small" (click) = "loadDailyProcess()">Refresh</button>
                    </div>
                </div>
                <canvas class="user-daily-process"></canvas>
            </div>
            <div class="separator"></div>
            <div class="class-erea class-mat-field" fxLayout="row" fxLayout.xs="column" fxFlex="50">
                <div class="class-mat-field" fxFlex="50">
                    <h3 class="stat-title">Current month Splitters</h3>
                    <canvas class="spliting-podium" height="250"></canvas>
                </div>
                <div class="separator"></div>
                <div class="class-mat-field" fxFlex="50">
                    <h3 class="stat-title">Current month Editors Words</h3>
                    <canvas class="editing-podium" height="260"></canvas>
                </div>
            </div>
        </div>
    </div>
    <div style="background-color: white; padding: 20px 20px 0px 20px;">
        <div class="class-erea" fxLayout="row" fxLayout.xs="column" style="height: 400px;">
            <div class="class-mat-field" fxFlex="30">
                <canvas class="global-project-content"></canvas>
            </div>
            <div class="separator"></div>
            <div class="class-mat-field" fxFlex="70">
                <canvas class="project-content"></canvas>
            </div>
        </div>
    </div>
    <div style="background-color: white; padding: 20px 20px 0px 20px;">
        <div class="class-erea" fxLayout="row" fxLayout.xs="column" style="height: 400px;">
            <div class="class-mat-field" fxFlex="70">
                <canvas class="raw-content"></canvas>
            </div>
            <div class="separator"></div>
            <div class="class-mat-field" fxFlex="30">
                <canvas class="global-raw-content"></canvas>
            </div>
        </div>
    </div>
    <div style="background-color: white; padding: 20px 20px 0px 20px;">
        <div class="class-erea" fxLayout="row" fxLayout.xs="column" style="height: 400px;">
            <div class="class-mat-field" fxFlex="20">
                <h2>Inscriptions</h2>
            </div>
            <div class="separator"></div>
            <div class="class-mat-field" fxFlex="80">
                <canvas class="available-content"></canvas>
            </div>
        </div>
    </div>
    <div style="padding-top: 20px; background-color: white;"></div>
</div>

